import { render } from "./screen-saver.vue?vue&type=template&id=73f89661&scoped=true&ts=true"
import script from "./screen-saver.vue?vue&type=script&lang=ts"
export * from "./screen-saver.vue?vue&type=script&lang=ts"

import "./screen-saver.vue?vue&type=style&index=0&id=73f89661&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f89661"]])

export default __exports__